import { forwardRef, type TextareaHTMLAttributes } from "react";

type PennTextareaProps = TextareaHTMLAttributes<HTMLTextAreaElement> & {
  error?: boolean;
};

export const PennTextarea = forwardRef<HTMLTextAreaElement, PennTextareaProps>(
  ({ error = false, className = "", rows = 4, ...props }, ref) => {
    const inactive = !!props.readOnly || !!props.disabled;
    return (
      <textarea
        ref={ref}
        rows={rows}
        {...props}
        className={[
          "w-full px-4 py-3 rounded-xl border text-sm text-penn-text placeholder-gray-400 outline-none transition resize-none focus:ring-2 focus:ring-penn-500 focus:border-penn-500 disabled:opacity-50 disabled:cursor-not-allowed",
          error
            ? "border-error bg-error/5"
            : inactive
              ? "border-gray-200 bg-gray-100"
              : "border-gray-200 bg-white hover:border-penn-500",
          className,
        ]
          .filter(Boolean)
          .join(" ")}
      />
    );
  },
);

PennTextarea.displayName = "PennTextarea";
